import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';

export class BrokersFilter extends BaseListFilter {
  search?: string;
  isVerified?: boolean = true;
  fetchBrokerApiUser?: boolean;
  skipIds?: number[];

  constructor(
    public sortBy: string = 'id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
